import { useParams } from 'react-router-dom';
import { useShort } from './shortContentQueries';
import { useVideoPlayerConfig } from '../video/videoHooks';
import { PLAYLIST_SEARCH_PARAM } from '../playlistContent/playlistContentConsts';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
import { useAssetStatus } from '../userProgress/userProgressQueries';
export const useShortContentParams = () => {
  const {
    shortId,
    playlistNavigation
  } = useParams();
  const [[playlistIdParam]] = useSearchParam(PLAYLIST_SEARCH_PARAM);
  return {
    shortId: shortId ? Number(shortId) : undefined,
    playlistId: playlistIdParam ? Number(playlistIdParam) : undefined,
    playlistNavigation
  };
};
export const useShortFromPropsOrParams = ({
  shortId: shortIdProp,
  playlistId: playlistIdProp
} = {}) => {
  const {
    shortId: shortIdParam,
    playlistId: playlistIdParam,
    playlistNavigation
  } = useShortContentParams();
  const shortId = shortIdProp || shortIdParam;
  const playlistId = playlistIdProp || playlistIdParam;
  return Object.assign({}, useShort(shortId, !shortId), {
    shortId,
    playlistId,
    playlistNavigation
  });
};
export const useShortVideo = ({
  shortId,
  skip
}) => {
  const {
    short
  } = useShort(shortId, skip);
  const {
    autoPlay,
    playSpeed
  } = useVideoPlayerConfig();
  if (!short) return null;
  const {
    reference,
    hubId,
    duration
  } = short;
  return {
    videoId: reference || '',
    autoPlay,
    playSpeed,
    creatorHubId: hubId,
    creatorRegion: short.contentHublet,
    businessObjectives: short.businessObjectives,
    useCases: short.useCases,
    videoDuration: duration
  };
};
export const useShortStatus = (id, skip) => useAssetStatus({
  id,
  type: 'SHORT_FORM_CONTENT',
  skip
});